import { Theme } from "../../../../providers/ThemeProvider";
import useTheme from "../../../../common/hooks/useTheme";
import CustomAutoComplete from "../common/CustomAutoComplete";
import { Box } from "@mui/material";
import { enReportServiceType } from "./helper";

type Props = {
  selectedServiceType: string | null;
  setSelectedServiceType: (value: string | null) => void;
  selectedService: string | null;
  setSelectedService: (value: string | null) => void;
  services: any[];
  isLoadingServices: boolean;
};

const ServiceBuilderStep1 = ({
  selectedServiceType,
  setSelectedService,
  setSelectedServiceType,
  selectedService,
  services,
  isLoadingServices,
}: Props) => {
  const theme: Theme = useTheme();
  // Exclude "Lab panel" (type 8) from service builder - only available in logic/prescription builders
  const serviceTypeOptions = Object.entries(enReportServiceType)
    .filter(([key]) => key !== "8")
    .map(([, value]) => value);

  return (
    <Box sx={{ display: "flex", gap: "16px" }}>
      <CustomAutoComplete
        label="Type"
        options={serviceTypeOptions}
        value={selectedServiceType}
        onChange={setSelectedServiceType}
      />
      <Box sx={{ flex: 1, position: "relative" }}>
        <CustomAutoComplete
          label="Name"
          options={services.map((service) => service.name)}
          value={selectedService}
          onChange={setSelectedService}
        />
        {isLoadingServices && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              marginTop: "4px",
              fontSize: "12px",
              fontFamily: "var(--font-Medium)",
              color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
            }}
          >
            Loading services...
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ServiceBuilderStep1;
